export enum CellDisclaimerDisplay {
    superscript = 'superscript',
    // tooltip = 'tooltip',
}



// WEBPACK FOOTER //
// ./src/models/configuration/explorer/CellDisclaimerDisplay.ts